export const LOAD_CATEGORIES = 'LOAD_CATEGORIES'
export const LOAD_INITIAL_DATA_FINISHED = 'LOAD_INITIAL_DATA_FINISHED'
export const SET_COMPRA_RAPIDA_MODAL = 'SET_COMPRA_RAPIDA_MODAL'
export const SET_BANNERS = 'SET_BANNERS'
export const SET_LOADING = 'SET_LOADING'
